import { useEffect, useState, useContext } from 'react';
import { downloadCumulativeExpensesReport, fetchCumulativeExpensesReports } from 'services/complianceReportsServices';
import AuthContext from "contexte/AuthContext"
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification';
import { launchError } from 'components/notifications';
import DownloaderLink from 'components/DownloaderLink/DownloaderLink';
import './cumulativeExpenses.css'

const CumulativeExpenses = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const data = await fetchCumulativeExpensesReports(user)
        setFiles(data);
      } catch (error) {
        launchError(t('notifications.reports.compliance.list.error'))
      }
    }

    fetchReportList();
  }, [])

  return (
    <DashboardLayout page={t(`pages_name.report_compliance_cumulative_expenses`)}>
      <Notification />
      <div className='cumulativeExpenses_titleComponent'>
        <h2>{t(`pages.cumulative_expenses.title`)}</h2>
        {/* <FilterComponent
          date={true}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          maxDate={yesterday}
        /> */}
      </div>
      <div>
        <ul>
          {files.map(file => (
            <DownloaderLink
              filename={`cumulative_expenses_${file}.xlsx`}
              fetchData={downloadCumulativeExpensesReport}
              fetchDataParams={{ user, fileName: file }}
              type={'excel'}
              display={file}
              key={file}
            />
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default CumulativeExpenses;